export default function tabs() {
  const containers = document.querySelectorAll('.js-tabs-container');
  console.log(containers);

  containers.forEach(container => {
    let togglesContainer = container.querySelector('.js-tabs-toggles');
    let bodiesContainer = container.querySelector('.js-tabs-bodies');
    if (!togglesContainer || !bodiesContainer) return;

    setUpTabs(togglesContainer, bodiesContainer);

    togglesContainer.addEventListener('click', event => {
      togglesContainer.querySelectorAll(':scope > *').forEach((toggle, index) => {
        if (event.target === toggle || toggle.contains(event.target)) {
          toggle.classList.add('is-active');
          bodiesContainer.querySelectorAll(':scope > *')[index].classList.add('is-active');
        }
        else {
          toggle.classList.remove('is-active');
          bodiesContainer.querySelectorAll(':scope > *')[index].classList.remove('is-active');
        }
      });
    })

    window.addEventListener('resize', event => {
      setUpTabs(togglesContainer, bodiesContainer);
    });
  });


  function setUpTabs(togglesContainer, bodiesContainer) {
    let maxHeight = 0;

    bodiesContainer.querySelectorAll(':scope > *').forEach((body, index) => {
      if (body.offsetHeight > maxHeight) maxHeight = body.offsetHeight;
      if (index === 0) {
        togglesContainer.querySelectorAll(':scope > *')[index].classList.add('is-active');
        body.classList.add('is-active');
      }
      // console.log(`${body.offsetHeight}px`);
    });

    bodiesContainer.style['height'] = `${maxHeight}px`;
  }
}